/** Created by azhou on 2019/2/22.*/
<template>
  <div class="blank_space">
    <left-text-border class="mb-3"
                      leftText="会议室名称"
                      placeholder="例如：潇湘会客厅"
                      required
                      v-model="MeetObj.title"/>
    <div class="d-center mb-2">
      <left-text-border class="w-50 mb-2  mr-2"
                  leftText="会议室面积"
                  v-model="MeetObj.area"
                  placeholder="面积"
                  appendText="m²"
                  required/>
      <left-text-border class="w-50 mb-2 ml-2"
                        leftText="层高"
                        v-model="MeetObj.high"
                        placeholder="层高"
                        appendText="m"
                        required/>
    </div>
    <div class="mb-3 d-center-start d-bj ">
      <left-text leftText="支持布局" required/>
        <el-checkbox-group v-model="MeetObj.layout" @change="handleCheckAllChange">
            <div v-for="item in layout" :key="item.id" class="d-layout">
              <el-checkbox :label="item.id" :value="item.id">
                <img :src="'/images/bj/icon_'+item.id+'.png'"/>
                <span>{{item.name }}</span>
                <el-input v-model="item.num" placeholder="可容纳" width="50px" :disabled="item.status">

                  <template slot="append">人数</template>
                </el-input>
              </el-checkbox>
            </div>
        </el-checkbox-group>
    </div>
    <div class="mb-3 d-center-start" >
      <left-text leftText="会议室柱子" required/>
      <el-radio-group v-model="MeetObj.pillar">
        <el-radio class="mr-2" :label="item.id" v-for="item in $GVAR.MeetingPillar" :key="item.name">{{item.name}}</el-radio>
      </el-radio-group>
    </div>
    <div class="mb-3 d-center-start" >
      <left-text leftText="会议室窗户" required/>
      <el-radio-group v-model="MeetObj.window">
        <el-radio class="mr-2" :label="item.id" v-for="item in $GVAR.MeetingWindow" :key="item.name">{{item.name}}</el-radio>
      </el-radio-group>
    </div>
    <left-text-checkbox 
      class="mb-3"
      leftText="会议室设备"                   
      v-model="MeetObj.facility"
      :options="$GVAR.MeetingEquipment"
    />
    <!-- <left-text-border class="mb-3"
                      leftText="备注"
                      placeholder="最长可添加80个字符"
                      type="textarea"
                      v-model="MeetObj.remark"/> -->
    <div class="mb-2 d-start-start">
      <left-text leftText="会议室相册"/>
      <upload-image @fileChange="(imgs)=>MeetObj.pic = imgs"
                    :existImgs="MeetObj.pic" :maxLength="10" editMode/>
    </div>
    <el-button @click="submitForm" class="mt-4 w-25 btn-login">提交</el-button>
  </div>
</template>

<script>
  import { mapGetters, mapActions,mapState} from 'vuex'
  import { UploadImages } from '@/assets/utils/uploadFiles'
  export default {
    name: 'AddEditMeet',
    props: {
      editObj: {},
      roomEdit: false,
    },
    computed: {
      ...mapState(['RoomMeetDetail','userLoginMessage']),
      ...mapGetters(['storeInfo','brand']),
      //判断是否是销售用户注册门店添加
      step() { return this.$route.query.step},
    },
    async created() {
      //获取会议详情信息
      if(this.editObj&&!this.editObj.id){return}
      await this.initial();
    },
    data () {
      return {
        MeetObj: {
          type: 1,
          pic: [],
          area: '',
          high:'',
          layout:[],
        },
        layout:[
            { id: 1, name: '剧院式',num:'',status:true},
            { id: 2, name: '课桌式',num:'',status:true},
            { id: 3, name: '岛屿式',num:'',status:true},
            // { id: 3, name: '鱼骨型',num:'',status:true},
            // { id: 4, name: 'U字形' ,num:'',status:true},
            // { id: 5, name: '回字型',num:'',status:true},
            // { id: 6, name: '宴会式',num:'',status:true},
        ],
      }
    },
    methods: {
      ...mapActions(['saveMeet','getMeetDetail']),
      /*编辑初始化信息*/
      async initial(){
        console.log(this.editObj.id);
        let data = {
          type:3,
          id:this.editObj.id
        }
        await this.getMeetDetail(data);
        //处理会议室布局
        this.RoomMeetDetail.layout_arr=Array.isArray(this.RoomMeetDetail.layout_arr)?this.RoomMeetDetail.layout_arr:[];
        console.log(this.isStringifyType(this.RoomMeetDetail.layout));
        console.log(this.RoomMeetDetail.layout);
        this.layout.forEach((item,index)=>{
              item.status=true;
              this.RoomMeetDetail.layout_arr.forEach(brand=>{
                if(brand.type===item.id){
                  item.status=false;
                  item.num=brand.num;
                }
              })
        })
        //只保留选中ID值
        this.RoomMeetDetail.layout=this.RoomMeetDetail.layout_arr.map(item=>item.type=item.type);
        //处理数字转字符串
        this.RoomMeetDetail.window=this.RoomMeetDetail.window.toString();
        this.RoomMeetDetail.pillar=this.RoomMeetDetail.pillar.toString();
        this.RoomMeetDetail.pic = this.$verify.stitch(this.RoomMeetDetail.pic).map(v => v);
        this.MeetObj = {...this.RoomMeetDetail};
      },
      /**
       * 判断一个值是否是经过 JSON.stringify() 处理后的 JSON 字符串
       * @param {any} value - 待判断的值
       * @returns {boolean} 是否为 stringify 类型（JSON 字符串）
       */
      isStringifyType(value) {
        // 第一步：先判断是否为字符串

        // 第二步：尝试解析 JSON，若成功则为 stringify 类型
        try {
          JSON.parse(value);
          return true;
        } catch (e) {
          return false;
        }
      },
      /*表单验证*/
      handleCheckAllChange(e){
        this.layout.forEach((item,index)=>{
            item.status=true;
            e.forEach(brand=>{
              if(brand===item.id){
                item.status=false;
              }
            })
          })
      },
      /*表单验证*/
      validateForm () {
        if (!this.MeetObj.title) return {code: false,msg: '请填写会议室名称'}
        if (!this.$GFUN.isFloatInteger(this.MeetObj.high)) return {code: false,msg: '会议室层高填写不正确'}
        if (!this.$GFUN.isFloatInteger(this.MeetObj.area)) return {code: false,msg: '会议室面积填写不正确'}
        if (this.MeetObj.layout.length <= 0) return {code: false,msg: '请选择会议室布局'};
        // 条件A：flag为true
         const conditionA = (obj) => obj.status === false;
        if (!this.$verify.allValidWhenConditionA(this.layout, conditionA, 'num')) return {code: false,msg: '请填写完整的会议室布局信息'};
        if (!this.MeetObj.pillar) return {code: false,msg: '请选择会议室柱子'}
        if (!this.MeetObj.window) return {code: false,msg: '请选择会议室窗户'}
        // if (this.MeetObj.pic.length <= 0) return {code: false,msg: '请至少上传一张会议室图片'}
        return {code: true,msg: '表单验证通过'}
      },
      /*提交表单*/
      submitForm () {
        let result = this.validateForm();
        if (result.code) {
          this._confirm('确认提交么？',async () => {
            let Meet=JSON.parse(JSON.stringify(this.MeetObj));
            //处理会议室布局
            let layoutArr = this.layout.filter(item => item.status === false);
            Meet.layout=[];
            layoutArr.forEach(item=>{
               Meet.layout.push({type:item.id,num:item.num})
            })
            Meet.layout=JSON.stringify(Meet.layout)
            //处理会议室相册
            Meet.pic = await UploadImages(Meet.pic);
            Meet.pic = Meet.pic
            let type = 'add';
            if (this.editObj&&this.editObj.id) {
              type = 'edit';
              switch (this.storeInfo.type) {
                case 8:
                case 3: Meet.meeting_id = Meet.id; break;
                case 5: Meet.homestay_meeting_id = Meet.id; break;
              }
            };
            //克隆房型添加
            if(this.c){
              delete Room.id;
              type = 'add';
            }
            //销售创建门店房型添加
            if(this.step){
              Meet.store_id = this.userLoginMessage.submit_store_id;
            }
            this.saveMeet({
              type,
              data: Meet,
              successFun: () => this.$emit('successFun')
            })
          })
        } else this._alert(result.msg,null,'error');
      }
    }
  }
</script>

<style scoped>
.blank_space ::v-deep .input-self-border{
  display: flex;
}
.d-bj .el-checkbox-group{
  width: 100%;
  display: flex;
  flex-wrap: wrap;  
}
.d-layout{
  width: 33%;
  display: flex;
  justify-content: left;
}
.d-layout img{
  width: 20px;
  height: 20px;
  display: block;
  float: left;
  margin-right: 6px;
  margin-top: 5px;
}
.d-layout span{
  width: 50px;
  display: inline-block;
} 
.d-layout input{
    border: 1px solid #dcdfe6;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    width: 110px;
    padding: 0 3%;
    border-radius: 3px;
    font-size: 12px;
    line-height: 32px;
}
</style>
<style>
  .d-bj .el-checkbox__label{
    text-align: left;
    font-size: 12px;
  }
  .d-layout .el-input-group{
    width: 120px;
  }
  .d-layout .el-input__inner{
    height: 32px;
    font-size: 12px;
  }
  .d-layout .el-input-group__append, .el-input-group__prepend{
    font-size: 12px;
  }
</style>